import { atom } from "jotai";
import { allQuotesAtom } from "./getters";
import { selectedPatientIdAtom } from "./selected-patient-atom";

export const selectedPatientReportsAtom = atom(get => {
  const allQuotes = get(allQuotesAtom);
  const selectedPatientId = get(selectedPatientIdAtom);

  return allQuotes?.filter(q => q.Contact_Name.id === selectedPatientId) ?? [];
});